import { apiClient, type ApiResponse } from './client'

export interface LessonPhoto {
  id: number
  componentKey?: string | null
  photoUrl: string
  uploadedByUserId: number
  uploadedByName: string | null
  uploadedAt: string
}
export interface LessonPhotos {
  learningAttemptId: number | null
  componentKey?: string | null
  editable: boolean
  maxPhotos: number
  photos: LessonPhoto[]
}
const path = (learnerId: number, lessonId: number) => `/lc/admin/coaching/learners/${learnerId}/lessons/${lessonId}/photos`
export const lcLessonPhotosApi = {
  list: async (learnerId: number, lessonId: number, learningAttemptId: number | null, componentKey: string | null = null): Promise<LessonPhotos> => {
    const params = {
      ...(learningAttemptId == null ? {} : { learningAttemptId }),
      ...(componentKey == null ? {} : { componentKey }),
    }
    const res = await apiClient.get<ApiResponse<LessonPhotos>>(path(learnerId, lessonId), { params: Object.keys(params).length ? params : undefined })
    return res.data.data
  },
  uploadUrl: async (learnerId: number, lessonId: number, learningAttemptId: number | null, contentType: string, componentKey: string | null = null): Promise<{ uploadUrl: string; fileUrl: string }> => {
    const res = await apiClient.post<ApiResponse<{ uploadUrl: string; fileUrl: string }>>(`${path(learnerId, lessonId)}/upload-url`, { learningAttemptId, contentType, componentKey })
    return res.data.data
  },
  confirm: async (learnerId: number, lessonId: number, learningAttemptId: number | null, fileUrl: string, componentKey: string | null = null): Promise<LessonPhoto> => {
    const res = await apiClient.post<ApiResponse<LessonPhoto>>(path(learnerId, lessonId), { learningAttemptId, fileUrl, componentKey })
    return res.data.data
  },
  remove: async (learnerId: number, lessonId: number, photoId: number, learningAttemptId?: number | null, componentKey: string | null = null): Promise<void> => {
    const params = {
      ...(learningAttemptId == null ? {} : { learningAttemptId }),
      ...(componentKey == null ? {} : { componentKey }),
    }
    await apiClient.delete(`${path(learnerId, lessonId)}/${photoId}`, { params: Object.keys(params).length ? params : undefined })
  },
  put: async (url: string, file: File, contentType: string) => {
    const response = await fetch(url, { method: 'PUT', body: file, headers: { 'Content-Type': contentType } })
    if (!response.ok) throw new Error('Photo upload failed')
  },
}
